export default {
    autoatendimento: 'Veus Autoservicio',
    home: {
        bemvindo: 'Bienvenido a',
        cadastrar: 'Registrar',
        orcamento: 'Consultar Presupuesto'
    },
    cadastro: {
        title: 'Formulario de inscripción',
        obrigatorio: 'El campo %s es obligatorio!',

        steps: {
            verificacao: 'Verificación',
            dados: 'Informaciones',
            dadospessoais: 'Informaciones personales',
            endereco: 'Dirección',
            documentos: 'Documentos',
            anterior: 'Anterior',
            proximo: 'Próximo',
            enviar: 'Enviar'
        },
        unidade: 'Unidade',
        documento: 'Pasaporte',

        nome: 'Nombre completo',
        email: 'Email',
        telefone: 'Celda',
        sexo: 'Género',
        masculino: 'Masculino',
        feminino: 'Mujer',
        nascimento: 'Fecha de nacimiento',
        //
        cep: 'Código postal',
        estado: 'Estado',
        cidade: 'Ciudad',
        bairro: 'Distrito',
        logradouro: 'Dirección',
        numero: 'Número',
        complemento: 'Complemento',

        identidade: 'Tarjeta de identificación',
        documentos: 'Guías TISS / Pedido de Exames / Tarjeta del plan de salud',
        
        documento_invalido: '¡Pasaporte inválido!',
        campos_invalidos: 'Campos Inválidos',
        mensagem: {
            sucesso: 'Registro hecho con éxito!',
            erro: 'Error al registrarse!'
        }
    },
    orcamentos: {
        consultar: 'Consultar',
        meusorcamentos: 'Mis Presupuestos'
    },
    qr: {
        obrigado: 'Gracias por usar',
        explicacao: 'Utilice este QRCode para ver su presupuesto y en el momento de su servicio',
        parafazer: 'Para concertar tu cita',
        cliqueaqui: 'Haga clic aquí',
        faleconosco: 'o contáctenos en',
        voltar: 'Volver al inicio',
        erro: 'Error al cargar su solicitud'
    },
    show: {
        aguardando: '¡Presupuesto de procesamiento!',
        atualizar: 'Actualizar',
        orcamento_sucesso: '¡Presupuesto generado con éxito!',
        funcionalidade_construcao: 'Funcionalidad en la Construcción'
    }
}
